var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAirplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4.2v12.4l-.72-.38a.614.614 0 00-.56 0l-.72.38V4.2c0-.55.45-1 1-1s1 .45 1 1zM9.8 7.94l-5.68 3.03c-.2.1-.32.31-.32.53v2.2c0 .2.1.38.26.49.1.07.22.11.34.11.07 0 .14-.01.21-.04l5.19-1.903v4.88L7.12 18.67c-.2.11-.32.31-.32.53v2.2c0 .2.1.38.26.49.16.11.36.14.55.07L12 20.35l4.39 1.61c.07.03.14.04.21.04.12 0 .24-.04.34-.11.16-.11.26-.29.26-.49v-2.2c0-.22-.12-.43-.32-.53l-2.68-1.432v-4.881l5.19 1.903c.07.03.14.04.21.04.12 0 .24-.04.34-.1.16-.11.26-.29.26-.49v-2.2c0-.22-.12-.43-.32-.53L14.2 7.95V4.2c0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2v3.74zm0 1.36L5 11.86v.98l4.8-1.76V9.3zm2.2 9.81c.07 0 .14.01.21.04L16 20.54v-.98l-4-2.13-4 2.13v.98l3.79-1.39c.07-.03.14-.04.21-.04zm2.2-8.03l4.8 1.76v-.98L14.2 9.3v1.78z"
  })));
}

export default SvgAirplane;